(() => {
  const urlParams = new URLSearchParams(window.location.search);
  const skValue = urlParams.get("sk");

  const attributes = [
    "sk",
    "utm_campaign",
    "utm_source",
    "utm_content",
    "utm_medium",
    "publisher",
    "campaign_name",
    "gclid",
    "fbclid",
  ];
  const attributeValues = {};

  for (const key of attributes) {
    const val = urlParams.get(key);

    if (val) {
      attributeValues[key] = val;

      if (typeof localStorage !== "undefined") {
        localStorage.setItem(key, val);
      }
    }
  }

  if (Object.keys(attributeValues).length > 0) {
    const formData = new FormData();

    for (const key in attributeValues) {
      const val = attributeValues[key];
      formData.append("attributes[_" + key + "]", val);
    }

    /*fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(data => {
        
      });*/
  }
})();

const _dsSetCookie = (name, value, days = 7, path = "/") => {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie =
    name +
    "=" +
    encodeURIComponent(value) +
    "; expires=" +
    expires +
    "; path=" +
    path;
};

const _dsGetCookie = (name) => {
  return document.cookie.split("; ").reduce((r, v) => {
    const parts = v.split("=");
    return parts[0] === name ? decodeURIComponent(parts[1]) : r;
  }, "");
};

const dsCartDrawer = ({ freeShipping, gifts, upsells, allProducts }) => {
  return {
    cart: null,
    total_price: 0,
    total_price_after_discount: 0,
    total_price_without_discount: 0,
    allProducts: allProducts,
    upsells: upsells,
    upsellsAvailable: false,
    discount: 0,
    upsellProduct: null,
    recommendations: {},
    itemsCap: [],
    itemsPaid: [],
    allPaidItems: [],
    itemsFree: [],
    discountCodeInput: null,
    validDiscountCode: null,
    codeStatus: null,
    discountedTotal: null,
    open: false,
    firstTimeOpened: false,
    shippingCost: 499,
    loading: false,
    discountLoading: false,
    items: [],
    choiceOverlay: false,
    //Section Cart Gifts
    freeShipping: freeShipping,
    gifts: gifts,
    selectedGifts: [],
    giftChoiceOpen: false,
    alert: false,
    giftSelectionSuccessful: false,
    selectedFreeVariants: [],
    nextGift: null,
    //End Cart Gifts
    sortGiftsBy(prop) {
      return function (a, b) {
        if (a[prop] > b[prop]) {
          return 1;
        } else if (a[prop] < b[prop]) {
          return -1;
        }
        return 0;
      };
    },
    giftAlreadyClaimed(giftProduct) {
      return this.items.find((s) => s.product_id == giftProduct.id);
    },
    giftAlreadyClaimedById(giftProductId) {
      return this.items.find((s) => s.product_id == giftProductId);
    },
    isSelectableGift(item) {
      for (const gift of this.gifts) {
        if (
          gift.max != undefined &&
          gift.products.find((product) => product.id == item.product_id)
        ) {
          return true;
        }
      }
      return false;
    },
    getCompareAtPrice(variant_id) {
      if (variant_id) {
        const itemsCap = this.itemsCap;
        const variant = itemsCap.find((variant) => {
          return variant.id?.toString() == variant_id?.toString();
        });
        if (variant) return variant.compare_at_price;
      }
      return false;
    },
    getTotalCompareAtPrice() {
      let total = 0;
      for (const item of this.items) {
        let compareAtPrice = this.getCompareAtPrice(item.variant_id);
        if (!compareAtPrice) compareAtPrice = item.price;
        if (compareAtPrice) {
          total += compareAtPrice * item.quantity;
        }
      }
      return total;
    },
    getTotalSavings() {
      return this.getTotalCompareAtPrice() - this.total_price;
    },
    getUnitPrice(variant_id) {
      const p = this.allProducts.find((p) => {
        const { variants } = p;
        const variant = variants.find((variant) => variant.id == variant_id);
        if (variant) return true;
        return false;
      });
      if (p) {
        const { variants } = p;
        const variant = variants.find((variant) => variant.id == variant_id);
        if (variant) return variant.unit_price;
      }
      return false;
    },
    getVariantTitle(variant_id) {
      const p = this.allProducts.find((p) => {
        const { variants } = p;
        const variant = variants.find((variant) => variant.id == variant_id);
        if (variant) return true;
        return false;
      });
      if (p) {
        const { variants } = p;
        const variant = variants.find((variant) => variant.id == variant_id);
        if (variant) return variant.variant_title;
      }
      return false;
    },
    widthBarStyle() {
      return `width: ${this.widthShippingBar()}%`;
    },
    isFreeShippingActivated() {
      const width = this.widthShippingBar();
      if (width < 100) {
        return false;
      }
      return true;
    },
    widthShippingBar() {
      let total = this.total_price_without_discount - this.discount;
      const freeShippingFrom = this.freeShipping.free_from;
      //console.log("freeShippingFrom", freeShippingFrom, total);
      if (total >= freeShippingFrom) {
        return 100;
      }
      return Math.abs(parseInt(total) / freeShippingFrom) * 100;
    },
    calculateTotalPriceWithoutDiscount() {
      const cap = this.getTotalCompareAtPrice();
      let p = 0;
      for (const capItem of this.itemsCap) {
        if (capItem.compare_at_price) {
          p += capItem.compare_at_price * capItem.quantity;
        } else {
          p += capItem.price * capItem.quantity;
        }
      }
      if (p > cap) {
        this.total_price_without_discount = p;
      } else {
        this.total_price_without_discount = cap;
      }
    },
    giftsAlreadySelected(blockId) {
      for (let gift of this.gifts) {
        if (gift.id == blockId) {
          let giftsInCart = 0;
          for (const item of this.items) {
            const f = gift.products.find(
              (s) => s.variants[0].id == item.variant_id
            );
            if (f) {
              giftsInCart++;
            }
          }
          return giftsInCart >= gift.max;
        }
      }
      return false;
    },
    freeShippingAfter(money_format) {
      return this.total_price_after_discount > this.freeShipping.free_from
        ? this.freeShipping.text_reached
        : this.giftDiff(money_format, this.freeShipping, null);
    },
    giftDiff(format, gift, nextGift) {
      let total = this.total_price - this.discount;
      const diff = gift.free_from - total;
      const nextGiftDiff = nextGift?.free_from - total;
      const t = gift.text.replace("[money]", Shopify.formatMoney(diff, format));
      if (diff < 0) {
        return this.freeShipping.text_reached;
      }
      return t.includes("[next_money]")
        ? t.replace("[next_money]", Shopify.formatMoney(nextGiftDiff, format))
        : t;
    },
    addGiftProduct(giftProduct) {
      if (typeof ga !== "undefined") {
        ga("send", "event", "Cart", "CartUpsell");
      }
      CartJS.addItem(
        giftProduct.id,
        1,
        {},
        {
          error: function (jqXHR, textStatus, errorThrown) {},
        }
      );
    },
    hasFreeShipping() {
      const diff =
        this.freeShipping.free_from - (this.total_price - this.discount);
      if (diff < 0) {
        this.shippingCost = 0;
        return true;
      } else {
        this.shippingCost = this.freeShipping.shipping_costs;
        return false;
      }
    },
    checkMandatories(mandatoryProducts) {
      if (mandatoryProducts == undefined || mandatoryProducts.length == 0) {
        return true;
      }
      let foundCount = 0;
      let notFound = [];
      for (product of mandatoryProducts) {
        if (!this.items.find((s) => s.product_id == product.id)) {
          notFound.push(product);
        }
      }
      return notFound;
    },
    confirmGiftChoice() {
      if (this.selectedFreeVariants.length < this.maxFreeProducts) {
        const free = this.maxFreeProducts - this.selectedFreeVariants.length;
        if (free == 1) {
          alert("Du hast noch ein Geschenk frei");
        } else {
          alert("Du hast noch " + free + " Geschenke frei");
        }
        this.giftSelectionSuccessful = false;
      } else {
        this.giftSelectionSuccessful = true;
        this.choiceOverlay = false;

        let i = 1;
        // Remove other free gifts
        for (const item of this.items) {
          const f = this.selectedFreeVariants.find((s) => s == item.variant_id);
          if (item.price == 0 && !f) {
            CartJS.removeItem(i);
          }
          i++;
        }

        // Add gifts that are not added yet
        for (const variant_id of this.selectedFreeVariants) {
          let alreadyInCart = false;
          const f = this.items.find((item) => item.variant_id == variant_id);

          if (f) alreadyInCart = true;

          if (!alreadyInCart) {
            CartJS.addItem(variant_id, 1);
          }
        }
      }
    },
    changeGift(item) {
      const i = this.items.findIndex((s) => s.id == item.id);
      if (i > -1) CartJS.removeItem(i + 1);
      this.selectedFreeVariants = this.selectedFreeVariants.filter(
        (s) => s != item.variant_id
      );
      this.setGiftToUnfulfilled(item);
    },
    removeGift(item) {
      const i = this.items.findIndex((s) => s.product_id == item.id);
      if (i > -1) CartJS.removeItem(i + 1);
    },
    setGiftToUnfulfilled(item) {
      for (gift of this.gifts) {
        if (gift.products.find((product) => product.id == item.product_id)) {
          gift.fulfilled = false;
          return;
        }
      }
    },
    toggleFreeProduct(product) {
      if (!product.available) {
        return;
      }

      const variant = product.variants[0].id;

      if (this.selectedFreeVariants.indexOf(variant) == -1) {
        this.selectedFreeVariants.push(variant);
      } else {
        const index = this.selectedFreeVariants.indexOf(variant);
        if (index > -1) {
          //console.log("remove ", variant)
          this.selectedFreeVariants.splice(index, 1);
        }
      }
      if (this.selectedFreeVariants.length > this.nextGift.max) {
        this.selectedFreeVariants.splice(0, 1);
      }
    },
    isFreeProductSelected(product) {
      const f = this.selectedFreeVariants.find(
        (v) => v.toString() == product.variants[0].id.toString()
      );
      return !!f;
    },
    loadRecommendations() {
      for (const item of this.items) {
        if (!this.recommendations[item.product_id]) {
          this.recommendations[item.product_id] = [];
          const url = `/recommendations/products.json?product_id=${item.product_id}`;
          var $this = this;
          fetch(url)
            .then((response) => response.json())
            .then((data) => {
              //console.log(data)
              $this.recommendations[item.product_id] = data?.products;
              if (data?.products?.length > 0) {
                $this.updateUpsellProduct();
              }
            });
        }
      }
    },
    updateUpsellProduct() {
      this.upsellProduct = null;

      var keys = Object.keys(this.recommendations);
      if (keys.length > 0) {
        for (let i = 0; i < 3; i++) {
          for (const product_id of Object.keys(this.recommendations)) {
            const products = this.recommendations[product_id];
            const hasProduct = this.items.find(
              (item) => item.product_id == product_id
            );

            if (hasProduct && !this.upsellProduct) {
              let newUpsellProduct;
              if (products.length > 0 && products[i]) {
                newUpsellProduct = products[i];
              }
              if (newUpsellProduct && this.cart && this.items.length > 0) {
                const cartProduct = this.items.find(
                  (item) => item.product_id == newUpsellProduct.id
                );

                if (!cartProduct) {
                  this.upsellProduct = newUpsellProduct;
                }
              }
            }
          }
        }
      }
    },
    loadImages() {
      for (const product of this.freeSelectableProducts) {
        fetch(
          `/search?view=id&type=product&q=${encodeURI(
            "id:" + product.productId
          )}`
        )
          .then((response) => response.json())
          .then((response) => {
            if (response.products && response.products.length > 0) {
              if (response.products[0].title) {
                product.title = response.products[0].title;
              }
              product.image = response.products[0].featured_image;
              product.product_worth = response.products[0].product_worth;
              product.available = !!response.products[0].available;
            }
          })
          .catch((err) => {});
      }
    },
    checkFreeItem(item) {
      let foundInGifts = this.gifts.find((gift) =>
        gift.products.find((product) => product.id == item.product_id)
      );
      if (!foundInGifts) {
        CartJS.removeItemById(item.variant_id);
      }
    },
    updateCompareAtPrice() {
      const $this = this;
      fetch("/cart?view=cap")
        .then((response) => response.json())
        .then((cart) => {
          $this.itemsCap = cart.items;

          $this.calculateTotalPriceWithoutDiscount();
        });
    },
    updateCart(cart) {
      console.log("------UPDATE CART------");

      console.log(this.cart);

      if (cart) {
        // Fetch additional cart data using GraphQL if we have a cart ID
        if (cart.id) {
          this.fetchCartDetailsWithGraphQL(cart.id);
        }

        this.updateCompareAtPrice();

        var discountCodeCookie = _dsGetCookie("discount_code");
        if (discountCodeCookie && !this.discountCodeInput) {
          this.discountCodeInput = discountCodeCookie;
          // Initialize discount code state from cookie
          this.validDiscountCode = discountCodeCookie;
          this.codeStatus = "valid";
        }
        this.cart = cart;
        this.total_price = cart.total_price;

        // Calculate discount from cart data
        if (cart.original_total_price > cart.total_price) {
          this.discount = cart.original_total_price - cart.total_price;
        } else if (cart.total_discount > 0) {
          this.discount = cart.total_discount;
        }

        this.items = cart.items;
        this.itemsPaid = cart.items.filter((item) => item.price > 0);
        this.itemsFree = cart.items.filter((item) => item.price == 0);
        this.itemsFree.forEach((item) => this.checkFreeItem(item));
        this.loadRecommendations();
        const $this = this;

        this.loading = false;
        this.calculateTotalPriceWithoutDiscount();

        // Update total_price_without_discount with original_total_price if available
        if (
          cart.original_total_price &&
          cart.original_total_price > cart.total_price
        ) {
          this.total_price_without_discount = cart.original_total_price;
        }

        if (!$this.validDiscountCode) {
          this.total_price_after_discount = this.total_price - this.discount;

          this.checkGiftClaims();
          this.checkUpsells();
        }

        this.shippingCost =
          this.total_price - this.discount > this.freeShipping.free_from * 100
            ? 0
            : 499;

        this.discountedTotal = this.getDiscountedTotal();

        // Check if we have a discount code from the cookie and initialize discount amount
        if (
          discountCodeCookie &&
          cart.discount_applications &&
          cart.discount_applications.length > 0
        ) {
          // If there are Shopify discount applications, use them
          this.discount = cart.discount_applications.reduce(
            (total, discount) => {
              return total + discount.amount;
            },
            0
          );
          this.codeStatus = "valid";
          this.validDiscountCode = discountCodeCookie;
        }

        // if ($this.validDiscountCode) {
        //   $this.triggerCheckout($this.validDiscountCode);
        // } else if (this.discountCodeInput) {
        //   $this.triggerCheckout(this.discountCodeInput);
        // }
      }
    },

    // Neue Funktion zum Abrufen der Cart-Details mit GraphQL
    fetchCartDetailsWithGraphQL(cartId) {
      // Storefront API-Token aus den Metadaten holen
      const storefrontAccessToken = document
        .querySelector('meta[name="shopify-storefront-api-token"]')
        ?.getAttribute("content");

      if (!storefrontAccessToken) {
        console.error("Fehler: Storefront API-Token nicht gefunden");
        return;
      }

      // GraphQL-Query zum Abrufen der Cart-Details
      const cartQuery = `
        query getCart($cartId: ID!) {
          cart(id: $cartId) {
            id
            checkoutUrl
            totalQuantity
            lines(first: 100) {
              edges {
                node {
                  id
                  quantity
                  merchandise {
                    ... on ProductVariant {
                      id
                      title
                      price {
                        amount
                      }
                      compareAtPrice {
                        amount
                      }
                      product {
                        id
                        title
                      }
                    }
                  }
                }
              }
            }
            cost {
              totalAmount {
                amount
              }
              subtotalAmount {
                amount
              }
              totalTaxAmount {
                amount
              }
              totalDutyAmount {
                amount
              }
            }
            discountCodes {
              code
              applicable
            }
            discountAllocations {
              discountedAmount {
                amount
              }
            }
          }
        }
      `;

      // Sende Anfrage an die Storefront API
      fetch("https://" + window.location.host + "/api/2023-07/graphql.json", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token": storefrontAccessToken,
        },
        body: JSON.stringify({
          query: cartQuery,
          variables: {
            cartId: cartId,
          },
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          console.log("GraphQL Cart Response:", data);

          if (data.data?.cart) {
            const graphQLCart = data.data.cart;

            // Berechne den Rabatt basierend auf der GraphQL-Antwort
            const subtotalAmount =
              parseFloat(graphQLCart.cost.subtotalAmount.amount) * 100;
            const totalAmount =
              parseFloat(graphQLCart.cost.totalAmount.amount) * 100;
            const discountAmount = subtotalAmount - totalAmount;

            console.log("GraphQL Discount Calculation:", {
              subtotal_cents: subtotalAmount,
              total_cents: totalAmount,
              discount_cents: discountAmount,
              formatted_subtotal: Shopify.formatMoney(subtotalAmount),
              formatted_total: Shopify.formatMoney(totalAmount),
              formatted_discount: Shopify.formatMoney(discountAmount),
            });

            // Wenn ein Rabatt vorhanden ist, aktualisiere die UI
            if (discountAmount > 0) {
              this.discount = discountAmount;
              this.total_price_without_discount = subtotalAmount;
              this.total_price = totalAmount;
              this.total_price_after_discount = totalAmount;

              // Trigger Alpine.js update
              if (typeof Alpine !== "undefined" && Alpine.version) {
                try {
                  // For Alpine.js v3+
                  if (Alpine.version[0] >= 3) {
                    Alpine.effect(() => {
                      console.log("Alpine effect triggered immediately after GraphQL update");
                    });
                  }
                  // For Alpine.js v2
                  else {
                    Alpine.updateElement(document.querySelector("[x-data]"));
                  }
                } catch (e) {
                  console.error("Error triggering Alpine update:", e);
                }
              }
            }
          }
        })
        .catch((error) => {
          console.error("Fehler beim Abrufen der Cart-Details:", error);
        });
    },

    checkUpsells() {
      for (upsell of this.upsells) {
        for (product of upsell.upsell_products) {
          if (this.upsellEligible(product, upsell.mandatory_products)) {
            this.upsellsAvailable = true;
            return;
          }
        }
      }
      this.upsellsAvailable = false;
    },
    checkAutomaticGifts(gift) {
      const missingRequiredProducts = this.checkMandatories(
        gift.mandatory_products
      );
      let mandatoryAmountFulfilled = false;
      if (gift.mandatory_amount == "one") {
        mandatoryAmountFulfilled =
          missingRequiredProducts.length <= gift.mandatory_products.length - 1;
      } else if (gift.mandatory_amount == "all") {
        mandatoryAmountFulfilled = missingRequiredProducts.length == 0;
      } else if (gift.mandatory_amount == "none") {
        mandatoryAmountFulfilled = true;
      }
      let codeMatches = false;
      console.log(
        "Code Matches",
        gift.code,
        this.discountCodeInput,
        gift.code?.toUpperCase()?.match(this.discountCodeInput?.toUpperCase())
      );
      if (gift?.code == "*") {
        codeMatches = true;
      } else {
        codeMatches =
          gift.code != ""
            ? this.discountCodeInput
                ?.toUpperCase()
                ?.match(gift.code?.toUpperCase()) != null
            : true;
      }
      //console.log("code Matches", codeMatches)

      //check if requiredProducts are in cart
      if (
        this.getDiscountedTotal() > gift.free_from * 100 &&
        mandatoryAmountFulfilled &&
        codeMatches
      ) {
        for (let product of gift.products) {
          const index = this.items.findIndex(
            (item) => item.product_id == product.id
          );
          if (index == -1) {
            this.addGiftProduct(product.variants[0]);
          }
        }
        gift.fulfilled = true;
        return;
      } else {
        gift.fulfilled = false;
        for (product of gift.products) {
          const index = this.items.findIndex((s) => s.product_id == product.id);
          if (index > -1) {
            this.removeGift(product);
            return true;
          }
          if (
            (this.nextGift != null &&
              !this.nextGift.fulfilled &&
              codeMatches &&
              this.nextGift?.free_from > gift.free_from) ||
            (this.nextGift == null && codeMatches) ||
            (this.nextGift != null && this.nextGift.fulfilled && codeMatches)
          ) {
            this.nextGift = gift;
            //CartJS.removeItem(index +1)
          }
        }
        if (!codeMatches) {
          gift.fulfilled = true;
          this.nextGift = undefined;
        }
      }
    },
    checkSelectedGifts(gift) {
      let fulfilled = false;
      let codeMatches =
        gift.code != ""
          ? this.discountCodeInput
              ?.toUpperCase()
              ?.match(gift.code?.toUpperCase()) != null
          : true;

      if (gift.code && !codeMatches) {
        return false;
      }
      const missingProductsInCart = this.checkMandatories(
        gift.mandatory_products
      );
      let mandatoryAmountFulfilled = false;
      if (gift.mandatory_amount == "one") {
        mandatoryAmountFulfilled =
          missingProductsInCart.length <= gift.mandatory_products.length - 1;
      } else {
        mandatoryAmountFulfilled = missingProductsInCart.length == 0;
      }

      if (gift.mandatory_products?.length == 0) {
        mandatoryAmountFulfilled = true;
      }
      /*console.log("codeMatches", gift.code, this.discountCodeInput, codeMatches);
      console.log("mandatoryAmountFulfilled", mandatoryAmountFulfilled, gift.mandatory_products)*/

      if (this.getDiscountedTotal() < gift.free_from * 100) {
        gift.variantPickable = mandatoryAmountFulfilled;
        for (product of gift.products) {
          const index = this.items.findIndex((s) => s.product_id == product.id);
          if (index > -1) {
            this.removeGift(product);
            fulfilled = false;
            gift.fulfilled = false;
            return true;
          }
          if (
            (this.nextGift != null &&
              codeMatches &&
              !this.nextGift.fulfilled &&
              this.nextGift?.free_from > gift.free_from) ||
            (this.nextGift == null && codeMatches)
          ) {
            this.nextGift = gift;
          }
          //CartJS.removeItem(index +1)
        }
      } else if (!mandatoryAmountFulfilled || !codeMatches) {
        for (product of gift.products) {
          const index = this.items.findIndex((s) => s.product_id == product.id);
          if (
            (this.nextGift != null &&
              codeMatches &&
              !this.nextGift.fulfilled &&
              this.nextGift?.free_from > gift.free_from) ||
            (this.nextGift == null && codeMatches)
          ) {
            this.nextGift = gift;
          }
          if (index > -1 || !mandatoryAmountFulfilled || !codeMatches) {
            this.removeGift(product);
            fulfilled = false;
            gift.fulfilled = false;
            return true;
          }
          return false;
        }
      } else {
        if (
          (this.nextGift != null &&
            codeMatches &&
            !this.nextGift.fulfilled &&
            this.nextGift?.free_from > gift.free_from) ||
          (this.nextGift == null && codeMatches) ||
          (this.nextGift != null && this.nextGift.fulfilled && codeMatches)
        ) {
          if (!fulfilled) {
            this.nextGift = gift;
          }
        }

        //console.log(gift.code, gift.fulfilled, gift.free_from, this.nextGift?.free_from, this.nextGift?.fulfilled, codeMatches)
      }

      if (
        this.allGiftsInCart(gift) &&
        mandatoryAmountFulfilled &&
        codeMatches
      ) {
        fulfilled = true;
        if (this.nextGift == gift) {
          this.nextGift = null;
        }
        return false;
      }
      gift.fulfilled = fulfilled;
      return false;
    },
    getDiscountedTotal() {
      return this.discountedTotal && _dsGetCookie("discount_code")
        ? this.discountedTotal
        : this.total_price;
    },
    allGiftsInCart(gift) {
      let found = 0;
      for (product of gift.products) {
        const index = this.items.findIndex((s) => s.product_id == product.id);
        if (index > -1) {
          found++;
        }
      }
      return found == gift.max;
    },
    upsellEligible(item, mandatoryProducts) {
      let found = false;
      const index = this.items.findIndex((s) => s.product_id == item.id);
      if (index > -1) {
        found = true;
      }
      let missingProducts = this.checkMandatories(mandatoryProducts);
      return !found && missingProducts.length < mandatoryProducts.length;
    },
    checkGiftClaims() {
      let checked = false;
      for (let gift of this.gifts) {
        //console.log("check selectable gift", gift.code)
        if (gift.max != undefined) {
          checked = this.checkSelectedGifts(gift);
          //console.log("checked", checked)
          if (checked) return;
        } else {
          checked = this.checkAutomaticGifts(gift);
          //console.log("checked", checked)
          if (checked) return;
        }
      }
    },
    applyDiscountCode() {
      var $this = this;
      console.log("=== DISCOUNT DEBUG START ===");
      console.log("Initial state:", {
        discountCodeInput: this.discountCodeInput,
        cart: this.cart
          ? {
              total_price: this.cart.total_price,
              item_count: this.cart.item_count,
            }
          : null,
        items_length: this.items.length,
        total_price_without_discount: this.total_price_without_discount,
        total_price: this.total_price,
        current_discount: this.discount,
      });

      if (this.discountCodeInput && this.cart && this.items.length > 0) {
        console.log("Discount code processing started");
        this.discountLoading = true;

        let code = this.discountCodeInput;
        code = code.trim().toLowerCase();
        if (code && code.indexOf("?") > -1) {
          const codeSplit = code.split("?");
          code = codeSplit[0];
          console.log("Code cleaned from query params:", code);
        }

        let shop = Shopify.shop;
        const data = {
          cart: JSON.parse(JSON.stringify(this.cart)),
          code: code,
          shop: shop,
        };
        console.log("Sending API request with data:", {
          code: code,
          shop: shop,
          cart_total: data.cart.total_price,
          cart_items_count: data.cart.items.length,
        });

        try {
          console.log(
            "API URL:",
            "https://secretbrands-checkout-api.digitalsprung.de/checkout"
          );
          console.log("Request headers:", {
            "Content-Type": "application/json",
          });

          fetch("https://secretbrands-checkout-api.digitalsprung.de/checkout", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
          })
            .then((response) => {
              console.log("API response received");
              console.log("API response status:", response.status);
              console.log("API response headers:", {
                contentType: response.headers.get("content-type"),
                contentLength: response.headers.get("content-length"),
              });

              // Zusätzliches Logging für den Response-Body als Text
              response
                .clone()
                .text()
                .then((text) => {
                  console.log(
                    "API response body (raw):",
                    text.substring(0, 500) + (text.length > 500 ? "..." : "")
                  );
                  try {
                    // Versuchen, den Text als JSON zu parsen, um zu sehen, ob es gültiges JSON ist
                    JSON.parse(text);
                    console.log("Response is valid JSON");
                  } catch (e) {
                    console.error("Response is not valid JSON:", e.message);
                  }
                })
                .catch((err) => {
                  console.error("Error reading response body as text:", err);
                });

              if (!response.ok) {
                console.error(
                  "API response not OK:",
                  response.status,
                  response.statusText
                );
                throw new Error(
                  `API response not OK: ${response.status} ${response.statusText}`
                );
              }

              return response.json().catch((err) => {
                console.error("Error parsing JSON response:", err);
                throw new Error("Failed to parse JSON response");
              });
            })
            .then((data) => {
              console.log("API response data parsed successfully");
              console.log("API response data:", data);

              this.discountLoading = false;
              console.log("Discount loading set to false");

              if (data.checkoutCart) {
                console.log("Before discount update:", {
                  current_discount: $this.discount,
                  current_total_price: $this.total_price,
                  current_total_after_discount:
                    $this.total_price_after_discount,
                });

                $this.discount = data.checkoutCart.discount;
                $this.total_price = data.checkoutCart.subtotal;
                $this.total_price_after_discount = data.checkoutCart.total;

                console.log("After discount update:", {
                  new_discount: $this.discount,
                  new_total_price: $this.total_price,
                  new_total_after_discount: $this.total_price_after_discount,
                  calculated_savings:
                    $this.total_price_without_discount -
                    ($this.total_price - $this.discount),
                });
              } else {
                console.log(
                  "No checkoutCart in response, resetting discount values"
                );
                $this.discount = 0;
                $this.total_price = $this.cart.total_price;
                $this.total_price_after_discount = $this.cart.total_price;
                console.log("Reset values:", {
                  discount: $this.discount,
                  total_price: $this.total_price,
                  total_after_discount: $this.total_price_after_discount,
                });
              }

              if (data.status) {
                console.log("Setting code status to:", data.status);
                $this.codeStatus = data.status;
              }

              if (data.checkoutCart && data.checkoutCart.discount == 0) {
                console.log("Discount is 0, setting code status to invalid");
                $this.codeStatus = "invalid";
              }

              if ($this.codeStatus == "valid") {
                console.log("Code is valid, updating UI and cookies");
                $this.validDiscountCode = code.trim().toUpperCase();
                $this.discountCodeInput = code.trim().toUpperCase();
                _dsSetCookie("discount_code", code.trim().toUpperCase(), 1);
                _dsSetCookie(
                  "discount_code_referrer",
                  code.trim().toUpperCase(),
                  1
                );

                var vdc = document.getElementById("cartDiscountCode");
                vdc && (vdc.value = code.trim().toUpperCase());
                console.log(
                  "Updated cartDiscountCode element:",
                  vdc ? vdc.value : "element not found"
                );

                var vd = document.getElementById("cartDiscount");
                vd && (vd.value = code.trim().toUpperCase());
                console.log(
                  "Updated cartDiscount element:",
                  vd ? vd.value : "element not found"
                );

                // UI-Elemente aktualisieren
                var cartItems = CartJS.cart.items;
                var items = [];
                let price = 0;
                for (var i = 0; i < cartItems.length; i++) {
                  items.push({
                    variant: cartItems[i].variant_id,
                    price: cartItems[i].price,
                    quantity: cartItems[i].quantity,
                  });
                  price += cartItems[i].price;
                }
                console.log("Cart items processed:", {
                  items_count: items.length,
                  total_price: price,
                });

                if (price == 0) {
                  console.log("Price is 0, clearing cart");
                  CartJS.clear();
                } else {
                  if (typeof EasyCart !== "undefined") {
                    console.log(
                      "Calling EasyCart hook: after_discount_code_check"
                    );
                    EasyCart.callHook("after_discount_code_check", [
                      code.trim(),
                      items,
                    ]);
                  }
                }
              } else {
                console.log(
                  "Code is invalid, setting validDiscountCode to null"
                );
                $this.validDiscountCode = null;
              }

              // Sofortige Aktualisierung der Alpine.js UI
              if (typeof Alpine !== "undefined" && Alpine.version) {
                try {
                  // For Alpine.js v3+
                  if (Alpine.version[0] >= 3) {
                    Alpine.effect(() => {
                      console.log("Alpine effect triggered immediately");
                    });
                  }
                  // For Alpine.js v2
                  else {
                    Alpine.updateElement(document.querySelector("[x-data]"));
                  }
                } catch (e) {
                  console.error("Error triggering Alpine update:", e);
                }
              }

              // Log the current state for debugging
              console.log("Final UI state:", {
                total_price: $this.total_price,
                total_price_without_discount:
                  $this.total_price_without_discount,
                discount: $this.discount,
                discountedTotal: $this.discountedTotal,
                total_price_after_discount: $this.total_price_after_discount,
                calculation_check:
                  $this.total_price_without_discount - $this.discount,
                formatted_original: Shopify.formatMoney(
                  $this.total_price_without_discount
                ),
                formatted_discount: Shopify.formatMoney($this.discount),
                formatted_final: Shopify.formatMoney(
                  $this.total_price_after_discount
                ),
                validDiscountCode: $this.validDiscountCode,
                codeStatus: $this.codeStatus,
              });

              // Cookies setzen
              _dsSetCookie(
                "discount_code",
                discountCode.trim().toUpperCase(),
                1
              );
              _dsSetCookie(
                "discount_code_referrer",
                discountCode.trim().toUpperCase(),
                1
              );
            })
            .catch((error) => {
              console.error("Detailed error in discount API call:", error);
              console.error("Error name:", error.name);
              console.error("Error message:", error.message);
              console.error("Error stack:", error.stack);
              $this.discountLoading = false;
              $this.codeStatus = "error";
              console.log("=== DISCOUNT DEBUG ERROR END ===");
            });
        } catch (outerError) {
          console.error("Outer try-catch error:", outerError);
          console.error("Outer error name:", outerError.name);
          console.error("Outer error message:", outerError.message);
          console.error("Outer error stack:", outerError.stack);
          $this.discountLoading = false;
          $this.codeStatus = "error";
          console.log("=== DISCOUNT DEBUG OUTER ERROR END ===");
        }
      } else {
        console.log("Discount code processing skipped. Requirements not met:", {
          has_discount_code: !!this.discountCodeInput,
          has_cart: !!this.cart,
          has_items: this.items.length > 0,
        });
        console.log("=== DISCOUNT DEBUG END ===");
      }
    },
    triggerCheckout(code) {
      const $this = this;

      // Set loading state immediately
      $this.discountLoading = true;

      // Vorbereiten der Warenkorb-Items für die Cart API
      const lineItems = this.itemsPaid.map((paidItem) => ({
        merchandiseId: `gid://shopify/ProductVariant/${paidItem.variant_id}`,
        quantity: paidItem.quantity,
      }));

      // Storefront API-Token aus den Metadaten holen
      const storefrontAccessToken = document
        .querySelector('meta[name="shopify-storefront-api-token"]')
        ?.getAttribute("content");

      if (!storefrontAccessToken) {
        console.error("Fehler: Storefront API-Token nicht gefunden");
        $this.discountLoading = false;
        return;
      }

      // GraphQL-Mutation zum Erstellen eines Carts
      const createCartMutation = `
        mutation cartCreate($input: CartInput!) {
          cartCreate(input: $input) {
            cart {
              id
              checkoutUrl
            }
            userErrors {
              field
              message
            }
          }
        }
      `;

      // Sende Anfrage an die Storefront API
      fetch("https://" + window.location.host + "/api/2023-07/graphql.json", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token": storefrontAccessToken,
        },
        body: JSON.stringify({
          query: createCartMutation,
          variables: {
            input: {
              lines: lineItems,
            },
          },
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.data?.cartCreate?.cart) {
            const cartId = data.data.cartCreate.cart.id;
            const checkoutUrl = data.data.cartCreate.cart.checkoutUrl;

            // Wenn ein Rabattcode vorhanden ist, diesen anwenden
            if (code) {
              return applyDiscountAndRedirect(cartId, checkoutUrl, code);
            } else {
              $this.discountLoading = false;
            }
          } else {
            console.error(
              "Fehler beim Erstellen des Carts:",
              data.errors || data.data?.cartCreate?.userErrors
            );
            $this.discountLoading = false;
          }
        })
        .catch((error) => {
          console.error("Fehler beim Checkout-Vorgang:", error);
          $this.discountLoading = false;
        });

      // Funktion zum Anwenden des Rabattcodes und Weiterleiten
      function applyDiscountAndRedirect(cartId, checkoutUrl, discountCode) {
        const discountMutation = `
          mutation cartDiscountCodesUpdate($cartId: ID!, $discountCodes: [String!]) {
            cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $discountCodes) {
              cart {
                id
                checkoutUrl
                discountCodes {
                  code
                  applicable
                }
                cost {
                  totalAmount {
                    amount
                  }
                  subtotalAmount {
                    amount
                  }
                }
              }
              userErrors {
                field
                message
              }
            }
          }
        `;

        return fetch(
          "https://" + window.location.host + "/api/2023-07/graphql.json",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-Shopify-Storefront-Access-Token": storefrontAccessToken,
            },
            body: JSON.stringify({
              query: discountMutation,
              variables: {
                cartId: cartId,
                discountCodes: [discountCode],
              },
            }),
          }
        )
          .then((response) => response.json())
          .then((data) => {
            console.log("Discount API response:", data);

            if (data.data?.cartDiscountCodesUpdate?.cart) {
              const cart = data.data.cartDiscountCodesUpdate.cart;
              const applicable = cart.discountCodes.some((dc) => dc.applicable);

              console.log("Discount code applicable:", applicable);
              console.log("Discount codes:", cart.discountCodes);

              if (applicable) {
                // Berechne den Rabatt basierend auf der API-Antwort
                const subtotalAmount =
                  parseFloat(cart.cost.subtotalAmount.amount) * 100;
                const totalAmount =
                  parseFloat(cart.cost.totalAmount.amount) * 100;

                // Wenn subtotal und total gleich sind, könnte der Rabatt noch nicht in der API-Antwort reflektiert sein
                // Wir setzen trotzdem den Rabattcode als gültig, auch wenn der Rabattbetrag 0 ist
                const discountAmount = subtotalAmount - totalAmount;

                // Prepare all updates before modifying the UI
                const updates = {
                  total_price_without_discount: subtotalAmount,
                  discount: discountAmount,
                  discountedTotal: totalAmount,
                  total_price_after_discount: totalAmount,
                  validDiscountCode: discountCode.trim().toUpperCase(),
                  codeStatus: "valid",
                };

                // If we have a cart, update its properties too
                if ($this.cart) {
                  $this.cart.total_price = totalAmount;
                  $this.cart.original_total_price = subtotalAmount;
                  updates.total_price = totalAmount;
                }

                // Apply all updates at once
                Object.assign($this, updates);

                // Now that all updates are applied, we can show the UI
                $this.discountLoading = false;

                // Trigger Alpine.js update
                if (typeof Alpine !== "undefined" && Alpine.version) {
                  try {
                    // For Alpine.js v3+
                    if (Alpine.version[0] >= 3) {
                      Alpine.effect(() => {
                        console.log("Alpine effect triggered immediately");
                      });
                    }
                    // For Alpine.js v2
                    else {
                      Alpine.updateElement(document.querySelector("[x-data]"));
                    }
                  } catch (e) {
                    console.error("Error triggering Alpine update:", e);
                  }
                }

                // Cookies setzen
                _dsSetCookie(
                  "discount_code",
                  discountCode.trim().toUpperCase(),
                  1
                );
                _dsSetCookie(
                  "discount_code_referrer",
                  discountCode.trim().toUpperCase(),
                  1
                );
              } else {
                // Rabattcode ist nicht anwendbar
                $this.codeStatus = "invalid";
                $this.discount = 0;
                $this.validDiscountCode = null;

                // Leere Eingabefelder
                var vdc = document.getElementById("cartDiscountCode");
                vdc && (vdc.value = "");

                var vd = document.getElementById("cartDiscount");
                vd && (vd.value = "");

                console.log("Discount code not applicable");
              }
            } else {
              console.error(
                "Error in discount code application:",
                data.errors || data.data?.cartDiscountCodesUpdate?.userErrors
              );
            }

            $this.discountLoading = false;
          })
          .catch((error) => {
            console.error("Fehler beim Anwenden des Rabattcodes:", error);
            $this.discountLoading = false;
          });
      }
    },

    // Neue Funktion zum Weiterleiten zum Checkout
    proceedToCheckout() {
      if (this.checkoutUrl) {
        window.location.href = this.checkoutUrl;
      }
    },
    decreaseQuantity(item) {
      this.loading = true;
      const index = this.items.findIndex((cartItem) => cartItem.id == item.id);
      CartJS.updateItem(index + 1, item.quantity - 1);
    },
    removeItem(item) {
      CartJS.updateItem(index + 1, item);
    },
    increaseQuantity(item) {
      this.loading = true;
      const index = this.items.findIndex((cartItem) => cartItem.id == item.id);
      CartJS.updateItem(index + 1, item.quantity + 1);
    },
    removeItem(item) {
      this.loading = true;
      const index = this.items.findIndex((cartItem) => cartItem.id == item.id);
      CartJS.removeItem(index + 1);
    },
    initialize(cart) {
      var $this = this;
      this.$watch("open", (value) => {
        if (value && !$this.firstTimeOpened) {
          $this.firstTimeOpened = true;
        }

        const trans = document.getElementById("rawa-container");
        if (trans) {
          if (value) {
            trans.style.display = "none";
          } else {
            trans.style.display = "block";
          }
        }

        const trustedBadge = document.querySelector(
          "[id^='trustbadge-container']"
        );
        if (trustedBadge) {
          if (value) {
            trustedBadge.style.display = "none";
          } else {
            trustedBadge.style.display = "block";
          }
        }

        const animatedTeaser = document.querySelector(
          "[data-testid='animated-teaser']"
        );
        if (animatedTeaser) {
          if (value) {
            animatedTeaser.style.display = "none";
          } else {
            animatedTeaser.style.display = "block";
          }
        }

        var body = document.querySelector("body");
        if (body) {
          if (value) {
            body.classList.add("overflow-hidden");
          } else {
            body.classList.remove("overflow-hidden");
          }
        }
      });

      this.gifts = this.gifts.sort(this.sortGiftsBy("free_from"), "desc");
      if (!cart) return;
      this.updateCart(cart);
    },
    calculateSavings() {
      const comparePrices = this.itemsPaid
        .map((item) => item.price * item.quantity)
        .reduce((a, b) => a + b, 0);
      const realPrices = this.total_price - this.discount;
      const savings = comparePrices - realPrices;
      
      return this.discount;
    },
    async validateDiscountCode(code) {
      console.log("validateDiscountCode called with code:", code);
      if (!code || code.trim().length === 0) {
        console.log("Invalid code: empty or whitespace");
        return false;
      }

      const formattedCode = code.trim().toUpperCase();

      console.log("formattedCode", formattedCode);
      console.log("validDiscountCode", this.validDiscountCode);

      // Check if this code is already applied
      if (formattedCode === this.validDiscountCode) {
        console.log("Code already exists:", formattedCode);
        this.codeStatus = "exist";
        this.discountLoading = false;
        return true;
      }

      // Speichere den aktuellen gültigen Code, falls vorhanden
      const previousValidCode = this.validDiscountCode;

      try {
        // Set loading state
        this.discountLoading = true;
        const shopUrl = window.location.hostname;

        // Hole den aktuellen Warenkorb vor der Anwendung des neuen Codes
        const cartBefore = await this.refreshCartData();
        const previousDiscount = cartBefore.total_discount;
        const previousDiscountApplications =
          cartBefore.cart_level_discount_applications || [];

        // Apply the discount code directly
        console.log(
          "Applying discount code via URL:",
          `https://${shopUrl}/discount/${formattedCode}`
        );

        await fetch(`https://${shopUrl}/discount/${formattedCode}`, {
          method: "GET",
          mode: "no-cors",
          credentials: "include",
        });

        // Get the updated cart to reflect any discounts
        const cart = await this.refreshCartData();

        // Speichere den aktuellen Zustand des Warenkorbs
        const currentDiscount = cart.total_discount;
        const hasDiscountApplications =
          cart.cart_level_discount_applications &&
          cart.cart_level_discount_applications.length > 0;

        // Prüfe, ob der Rabattcode gültig ist
        if (currentDiscount > 0 || hasDiscountApplications) {
          console.log("Discount code was applied successfully");

          // Store the discount information
          this.total_discount = cart.total_discount;
          this.total_price_after_discount = cart.total_price;

          // Update discount status
          this.codeStatus = "valid";
          this.validDiscountCode = formattedCode;

          // Save the discount code to a cookie for persistence
          _dsSetCookie("discount_code", formattedCode, 1);

          // Check for free shipping discount
          const hasFreeShipping =
            hasDiscountApplications &&
            cart.cart_level_discount_applications.some(
              (discount) =>
                discount.type === "shipping" ||
                (discount.value_type === "percentage" && discount.value === 100)
            );

          if (hasFreeShipping) {
            this.freeShippingFromDiscountCode = true;
            this.shippingCost = 0;
          }

          // Check for gift eligibility after applying discount
          this.checkGiftClaims();

          this.discount = cart.total_discount;

          this.discountLoading = false;
          this.total_price = cart.total_price;

          return true;
        } else {
          // Wenn der Code ungültig ist
          console.log("Invalid discount code");

          // Wenn es einen vorherigen gültigen Code gab, diesen wiederherstellen
          if (previousValidCode) {
            console.log("Restoring previous valid code:", previousValidCode);

            // Entferne den ungültigen Code
            await fetch(`https://${shopUrl}/discount/clear`, {
              method: "GET",
              mode: "no-cors",
              credentials: "include",
            });

            // Warte kurz, damit der Clear-Befehl wirksam wird
            await new Promise((resolve) => setTimeout(resolve, 300));

            // Wende den vorherigen gültigen Code wieder an
            await fetch(`https://${shopUrl}/discount/${previousValidCode}`, {
              method: "GET",
              mode: "no-cors",
              credentials: "include",
            });

            // Behalte den vorherigen Status bei
            this.validDiscountCode = previousValidCode;
            this.codeStatus = "valid";

            // Zeige Fehlermeldung für den neuen ungültigen Code
            this.tempInvalidCode = formattedCode;

            this.tempInvalidCode = null;
          } else {
            // Wenn es keinen vorherigen Code gab, setze auf "invalid"
            this.codeStatus = "invalid";
            this.validDiscountCode = null;
          }

          this.discountLoading = false;
          return false;
        }
      } catch (error) {
        console.error("Error validating discount code:", error);

        // Bei Fehler den vorherigen Code wiederherstellen, falls vorhanden
        if (previousValidCode) {
          try {
            const shopUrl = window.location.hostname;

            // Entferne den ungültigen Code
            await fetch(`https://${shopUrl}/discount/clear`, {
              method: "GET",
              mode: "no-cors",
              credentials: "include",
            });

            // Warte kurz, damit der Clear-Befehl wirksam wird
            await new Promise((resolve) => setTimeout(resolve, 300));

            // Wende den vorherigen gültigen Code wieder an
            await fetch(`https://${shopUrl}/discount/${previousValidCode}`, {
              method: "GET",
              mode: "no-cors",
              credentials: "include",
            });

            // Behalte den vorherigen Status bei
            this.validDiscountCode = previousValidCode;
            this.codeStatus = "valid";
          } catch (restoreError) {
            console.error(
              "Error restoring previous discount code:",
              restoreError
            );
          }
        } else {
          this.codeStatus = "invalid";
          this.validDiscountCode = null;
        }

        this.discountLoading = false;
        return false;
      }
    },
    async refreshCartData() {
      try {
        const response = await fetch("/cart.js");
        if (!response.ok) {
          throw new Error(
            `Failed to fetch cart: ${response.status} ${response.statusText}`
          );
        }
        return await response.json();
      } catch (error) {
        console.error("Error fetching cart data:", error);
        throw error;
      }
    },
  };
};

function parse_query_string(query) {
  var vars = query.split("&");
  var query_string = {};
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
    var key = decodeURIComponent(pair[0]);
    var value = decodeURIComponent(pair[1]);
    // If first entry with this name
    if (typeof query_string[key] === "undefined") {
      query_string[key] = decodeURIComponent(value);
      // If second entry with this name
    } else if (typeof query_string[key] === "string") {
      var arr = [query_string[key], decodeURIComponent(value)];
      query_string[key] = arr;
      // If third or later entry with this name
    } else {
      query_string[key].push(decodeURIComponent(value));
    }
  }
  return query_string;
}
